import { Download } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';

export function BackupSection() {
  return (
    <div className="flex flex-col gap-4">
      <div className="border-border bg-card flex flex-col gap-2 rounded-md border p-4">
        <h3 className="font-display text-lg font-semibold">Export all data</h3>
        <p className="text-muted-foreground text-sm">
          Downloads a single JSON file with your cards, attempts, sessions, daily activity,
          settings, and streak state. Useful as a backup or for moving to a new deployment.
        </p>
        <Button asChild className="self-start">
          <a href={api.exportUrl()} download>
            <Download className="size-4" />
            Download backup
          </a>
        </Button>
      </div>
    </div>
  );
}
